<template>
  <v-main>
      <div
        :class="[$vuetify.breakpoint.mdAndUp && 'fill-height']"
        class="d-block d-md-flex"
      >
        <page-app-bar />

        <router-view />

        <page-footer />
      </div>
  </v-main>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'

  export default {
    name: 'PageView',

    components: {
      PageAppBar: () => import('./AppBar'),
      PageFooter: () => import('./Footer'),
    },

    data: () => ({
      srcs: {
        '/pages/lock/': 'dark-green.jpg',
        '/pages/login/': 'dark-green.jpg',
        '/pages/pricing/': 'dark-green.jpg',
        '/pages/register/': 'dark-green.jpg',
      },
    }),

    computed: {
      path: get('route/path'),
      src () {
        return this.srcs[this.path] || 'dark-green.jpg'
      },
    },
  }
</script>
